import { Grid, Typography } from '@mui/material';
import { decimalToString } from '../../../../utils/formatNumber';
import React from 'react';
import { injectIntl } from 'react-intl';

const ColouredCurrencyStyle = {
  borderBottom: '1px solid #dcdcdc',
  width: 'auto'
};

const ColoredCurrency = props => {
  const { intl, currency, color, value, fontSize, bold } = props;
  return (
    <Grid
      container
      spacing={1}
      style={ColouredCurrencyStyle}
      sx={{
        justifyContent: "center",
        alignItems: "center"
      }}>
      {/* <Grid>
        <Typography color="textSecondary">{intl.formatMessage({ id: currency })}</Typography>
      </Grid> */}
      <Grid style={{ flexGrow: 1, minWidth: 68 }}>
        <Typography style={{ color: color, fontSize: fontSize, fontWeight: bold ? 'bold' : undefined }}>
          {decimalToString(value)}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default injectIntl(ColoredCurrency);
